import { Paper, styled } from '@mui/material';

export const StyledGradeBookLessonWrap = styled(Paper)(() => ({
	position: 'relative',
	display: 'flex',
	flexDirection: 'column',
	gap: '4px',
	padding: '8px',
	borderRadius: '12px',
	border: '1px solid  #F1F8FE',
	background: '#FFF',
	boxShadow: '0 0 30px 0 rgba(130, 125, 131, 0.15)',
}));
